import moment from "moment";

export const getUserData = () => {
  const jsonValue = localStorage.getItem("@user");
  if (jsonValue) return JSON.parse(jsonValue);
  else return null;
};

export const getUserRole = () => {
  try {
    const userRole = JSON.parse(localStorage?.getItem("userRole"));
    return userRole?.name || null;
  } catch (e) {
    return null;
  }
};

export const getBearerToken = async () => {
  try {
    const token = localStorage.getItem("token");
    if (token) return token;
    return null;
  } catch (error) {
    console.error("Error retrieving refresh token from localStorage:", error);
    return null;
  }
};
export const getRefreshToken = () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    if (refreshToken) return refreshToken;
    return null;
  } catch (error) {
    console.error("Error retrieving refresh token from localStorage:", error);
    return null;
  }
};
export const getTokenExpiry = () => {
  try {
    const tokenExpiry = localStorage.getItem("tokenExpiry");
    if (tokenExpiry) return tokenExpiry;
    return null;
  } catch (error) {
    console.error("Error retrieving refresh token from localStorage:", error);
    return null;
  }
};
export const setTokensAndExpiry = (bearerToken, refreshToken, tokenExpiry) => {
  localStorage.setItem("token", bearerToken);
  localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("tokenExpiry", tokenExpiry);
};
export function isTokenExpire(tokenExpiry) {
  if (!tokenExpiry) return false;
  const localTime = moment(tokenExpiry).local().format("YYYY-MM-DDTHH:mm:ss");
  const currentTime = new Date();
  const expiryTime = new Date(localTime);
  const differenceInMillis = expiryTime.getTime() - currentTime.getTime();
  if (differenceInMillis <= 60000) return true;
  return false;
}
